import './styles/index.css'
import './styles/marketing.css'
import App from './App.js'

const app = document.getElementById('app')
app.innerHTML = ''
app.appendChild(App())
